<template>
	<div class="login-box">
		<div class="login-box-head">
			<span>账号登陆</span>
		</div>
		<el-form :model="formInline" class="login_form">
			<div class="login-input-prefix">
				<el-input prefix-icon="el-icon-user" v-model="formInline.username"
					:placeholder="formInline.sign==0?'监督姓名':'账号'"></el-input>
			</div>
			<div class="login-input-prefix">
				<el-input prefix-icon="el-icon-lock" v-model="formInline.password" @keyup.enter.native="onSubmit"
					show-password :placeholder="formInline.sign==0?'身份证号':'密码'" type="password"></el-input>
			</div>
			<el-form-item class="login-input-prefix">
				<el-input placeholder="验证码" style="width: 55%" v-model="formInline.code" @keyup.enter.native="onSubmit">
					<i slot="prefix" class="el-input__icon ali-iconfont icon-anquan" style="display: block"></i>
				</el-input>
				<div class="login-code">
					<img :src="codeUrl" @click="getCodeImgs" />
				</div>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSubmit" :loading="loading"
					style="width:100%;height: 38px;font-weight: bold;">
					<span style="font-size: 16px;" v-if="!loading">登 录</span>
					<span style="font-size: 16px;" v-else>登 录 中...</span>
				</el-button>
			</el-form-item>
			<div class="zc">
				<div>
					<!-- <el-link type="primary" :underline="false">密码找回</el-link>
					<el-divider direction="vertical"></el-divider> -->
<!--					<el-link type="primary" :underline="false" href="/register">供应商注册</el-link>-->
				</div>
			</div>
		</el-form>
	</div>

</template>

<script>
	import {
		getCodeImg
	} from '@/api/login'
	import {
		Encrypt
	} from '@/utils/AES.js'

	export default {
		data() {
			return {
				formInline: {
					username: "",
					password: "",
					imgUuid: undefined,
					code: '',
					sign: 1
				},
				loading: false,
				redirect: undefined,
				codeUrl: "",
				fangwenliang: 0, // 历史访问量
				rules: {
					username: [{
						required: true,
						message: '请输入账号',
						trigger: 'blur'
					}],
					password: [{
							required: true,
							message: '请输入密码',
							trigger: 'blur'
						},
						{
							pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/,
							message: "请输入8-16位数字和字母组成的密码",
							trigger: "blur"
						}
					],
					identityCard: [{
							required: true,
							message: '请选择身份证',
							trigger: 'blur'
						},
						{
							pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
							message: "请输入合法的身份证",
							trigger: "blur"
						}
					],
					phone: [{
							required: true,
							message: "手机号码不能为空",
							trigger: "blur"
						},
						{
							pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
							message: "请输入正确的手机号码",
							trigger: "blur"
						}
					]
				},
			};
		},
		watch: {
			$route: {
				handler: function(route) {
					this.redirect = route.query && route.query.redirect;
				},
				immediate: true
			}
		},
		created() {
			this.getCodeImgs();
			this.clearStore();
			console.log(this.redirect)
			//this.getOnlineCount();
		},
		methods: {
			switchFun: function(sign) {
				let _this = this;
				_this.formInline.sign = sign

			},
			//获取 验证码
			getCodeImgs() {
				getCodeImg().then(({
					data
				}) => {
					if (data.code == 0) {
						this.codeUrl = "data:image/gif;base64," + data.data.img;
						this.formInline.imgUuid = data.data.uuid;
					} else {
						this.$fail(data.msg);
					}
				})

			},
			//只要到登录页面就清空  store 里面的tab信息
			clearStore() {
				this.$store.state.app.openTab = [{
					name: '首页',
					title: '首页',
					route: '/welcome'
				}];
				this.$store.state.app.cachedViews = ['Home'];
				this.$store.state.app.activeIndex = '/welcome';
			},
			onSubmit() {
				let _this = this;
				let param = JSON.parse(JSON.stringify(this.formInline));
				if (!param.username) {
					_this.$fail('账号不能为空');
					return false;
				} else if (param.password) {
					param.password = Encrypt(param.password);
				} else {
					_this.$fail('密码不能为空');
					return false;
				}
				_this.loading = true;
				_this.$store.dispatch("user/Login", param).then(function(res) {
					_this.loading = false;
					if (res.data.code == 0) {
						// console.log('跳转=====_this.redirect || "/welcome"')
						// console.log(_this.redirect || "/welcome")
						_this.$replace({
							// path: _this.redirect || "/welcome"
							path: "/welcome"
						})
					}
					// else {
					// 	_this.$fail(res.data.msg);
					// 	_this.getCodeImgs();
					// }
				}).catch(function(res) {
					_this.loading = false;
				});

			},
		}
	};
</script>

<style scoped="scoped" lang="scss">
	/deep/ .el-link.el-link--primary{
		color: #29BECE;
	}
	/deep/ .el-divider{
		background-color: #29BECE;
	}
	/deep/ .el-button--primary{
		background-color: #29BECE;
    	border-color: #29BECE;
	}
	.login-box {
		height: 100%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.login_form {
		width: 90%;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
		flex: 1;
	}

	.login-head {
		width: 90%;
		height: 44px;
		display: flex;
		flex-direction: row;
		justify-content: flex-start;
		font-size: 18px;
	}

	.login-box-head {
		width: 90%;
		height: 35px;
		line-height: 35px;
		color: #333;
		font-size: 14px;
		text-indent: 3px;
		letter-spacing: 0.5px;
		margin-bottom: 5px;
	}

	.el-divider--horizontal {
		margin: 1px 0;
	}

	.login-input-prefix {
		margin-bottom: 13px;
	}

	.login-code {
		height: 36px;
		float: right;

		img {
			cursor: pointer;
		}
	}

	.zc {
		height: 30px;
		font-size: 13px;
		line-height: 30px;
		text-align: right;
		vertical-align: middle;

	}

	.el-link {
		font-size: 13px;
	}

	.zc /deep/ .el-divider--vertical {
		width: 1px;
	}

	.sy-hove:hover {
		color: #409EFF;
	}

	.ali-iconfont {
		font-size: 14px;
	}
</style>
